var utility = {
  init: function(){
    utility.checkMobile();
    utility.checkMobileOrTablet();
    utility.dates.init();
    utility.forms.init();
    utility.fields.init();
    utility.sidebar.init();
    utility.masks.init();
  },
  ajaxInterceptor: {
    init: function() {
      const STATUS_CODE_UNAUTHORIZED = 401;
      const STATUS_CODE_FORBIDDEN = 403;

      const UNAUTHORIZED_STATUSSES = [STATUS_CODE_UNAUTHORIZED, STATUS_CODE_FORBIDDEN];

      $(document).ajaxError(function( event, jqxhr, settings, thrownError ) {
        if (UNAUTHORIZED_STATUSSES.includes(jqxhr.status)) {
          return window.parent.postMessage({ type: '@redirect/REDIRECT',  url: '/login.php' } , '*');
        }
      });

      $(document).ajaxSend(function(_, request) {
        if (currentCompanyId) {
          request.setRequestHeader('x-company-id', currentCompanyId);
        }
      });
    },
  },
  clearFields: function(el) {
    $(el).find(':input').each(function() {
      switch(this.type) {
        case 'password':
        case 'text':
        case 'textarea':
        case 'file':
        case 'select-one':
        case 'select-multiple':
        case 'date':
        case 'number':
        case 'tel':
        case 'email':
        $(this).val('');
        break;
        case 'checkbox':
        case 'radio':
        this.checked = false;
        break;
      }
    });
    
    $(el).find('.indexer.multidate').each(function() {
      var $indexerMultidate = $(this).children('.form-group').find('input[multidate="true"]');
      
      if($indexerMultidate.is('[required]')) {
        $(this).find('.multidates .field:not(:first-child)').remove();
        $indexerMultidate.val(1);
        $indexerMultidate.trigger('click');
      }
      else {
        $(this).find('.multidates .field').remove();
      }
    });
  },
  blurTarget: function(evt) {
    evt.currentTarget.blur();
  },
  clearLocalStorage: function() {
    // this prevents from removing UserGuiding data
    // currently the PHP project uses these keys to retrieve user information
    // we'll be able to remove this big list after updating the PHP
    // to get info from a single localStorage key
    const keysToRemove = [
      'userInfo',
      'sessionId',
      'firstAccess',
      'legalAgreements',
      'customerId',
      'vn-session-id',
      'userOutAD',
      'userType',
      'userAssume.userAssumeName',
      'userAssume',
      'hasAD',
      'userAssumeEstablishmentList',
      'customerLabelsDisplay.labelEstablishmentGroup',
      'userId',
      'multiFactorAuthentication',
      'userAssumeRoleList',
      'userNickname',
      'customerLabelsDisplay.labelCompany',
      'hasProcessSituation',
      'userAssume.adminUserId',
      'customerLabelsDisplay.labelEstablishment',
      'approvedMFA',
      'hasMultipleCompany',
      'vn__quick-filters_count',
      'roles',
      'customerResource',
      'image',
      'resourceList',
      'userCompany',
      'userName',
      'endImagem',
      'userChangedProfile',
      'redirectTo',
      'vn-sessions',
      'hasConference',
      'companyName',
      'customerLabelsDisplay'
    ];

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  },
  array: {
    removeFrom: function(array,propertyName,propertyValue){
      array = $.map(array,function(item){
        if(eval('item.' + propertyName) != propertyValue) return item;
      });
      return array;
    }
  },
  isMobile: null,
  checkMobile: function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    utility.isMobile = check;
  },
  isMobileOrTablet: null,
  checkMobileOrTablet: function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      utility.isMobileOrTablet = check;
    },
    toggleCheck: function(inputRadio){
      $('[name="' + inputRadio + '"]').prop('checked',$('[name="' + inputRadio + '"]').prop('checked'));
    },
    date: {
      correct: function(date){
        var initial = date.split(/-/);
        return ([ initial[2], initial[1], initial[0] ].join('/'));
      },
      convertTimestamp: function(date){
        var d = new Date(date);
        return (d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear());
      },
      convertTimestampWithTime: function(date){
        var d = new Date(date);
        var day = d.getDate();
        var month = (d.getMonth() + 1).toString();
        
        if(month.length == 1) month = '0' + month;
        
        var year = d.getFullYear();
        
        var hour = d.getHours().toString();
        if(hour.length == 1) hour = '0' + hour;
        
        var minutes = d.getMinutes().toString();
        if(minutes.length == 1) minutes = '0' + minutes;
        
        var seconds = d.getSeconds().toString();
        if(seconds.length == 1) seconds = '0' + seconds;
        
        return (day + '/' + month + '/' + year + ' ' + hour + ':' + minutes + ':' + seconds);
      }
    },
    delay: function(time){
      return new Promise(function(resolve){
        setTimeout(function(){ resolve() },time);
      });
    },
    draw: {
      getIndexerHTML: function(indexer, classes){
        return new Promise(function(resolve){
          var indexer_id, hasValidation, custom_validation = '', mask_TAG = '', readOnly_TAG, let_type_TAG, required_TAG, indexer_HTML, validation, value;
          
          indexer_id = indexer.indexerId;
          hasValidation = indexer.indexerType.validationType != null;
          value = indexer.indexerValue ? indexer.indexerValue : '';
          
          if(hasValidation && indexer.indexerType.validationType.validationFront != null){
            validation = indexer.indexerType.validationType.validationFront ? indexer.indexerType.validationType.validationFront : 'validateIfIsEmpty';
            custom_validation = 'utility.validation.' + validation + '(this)';
            mask_TAG = indexer.indexerType.validationType.mask;
          }
          
          required_TAG = indexer.required ? 'required' : '';
          
          readOnly_TAG = indexer.readonly || indexer.readOnly ? ' readonly ' : '';
          
          let_type_TAG = indexer.let_type ? ' let_type ' : '';

          const indexerMaxLength = indexer.maxLenght ? parseInt(indexer.maxLenght) : null;
          const maxLength = mask_TAG ? null : indexerMaxLength;

          var indexer_obj = {
            classes: classes,
            parent_id: indexer.parentId,
            indexer_id: indexer_id,
            days_restriction: indexer.qtyDaysRestriction,
            list: indexer.list,
            indexer_label: indexer.label,
            indexer_name: indexer.indexerName,
            indexer_type_name: indexer.indexerType.name,
            indexer_type: indexer.indexerType.dataType.dataTypeInitials,
            has_datepicker_TAG: (indexer.indexerType.dataType.dataTypeInitials == 'D' ? ' has-datepicker ' : ''),
            sequence: indexer.sequence,
            custom_validation: custom_validation,
            readOnly_TAG: readOnly_TAG,
            let_type_TAG: let_type_TAG,
            multiple: indexer.multiple,
            flagStickField_TAG: (indexer.flagStickField ? ' stick ' : ''),
            mask_TAG: mask_TAG,
            max_TAG: (indexer.maxLenght ? '9'.repeat(parseInt(indexer.maxLenght)) : null),
            maxLength_TAG: maxLength,
            required_TAG: required_TAG,
            required: indexer.required,
            value: value
          };
          
          utility.render('common/indexer',indexer_obj).then(resolve);
        });
      },
      getCaptureIndexersHTML: function(indexers, classes){
        return new Promise(function(resolve){
          var hasValidation, custom_validation, mask_TAG, let_type_TAG, required_TAG, readOnly_TAG, validation;
          
          indexers = $.map(indexers, function(indexer){
            custom_validation = '';
            mask_TAG = '';
            let_type_TAG = indexer.let_type ? ' let_type ' : '';
            readOnly_TAG = indexer.readonly || indexer.readOnly ? ' readonly ' : '';
            hasValidation = indexer.indexerType.validationType != null;

            if (hasValidation) {
              if (indexer.indexerType.validationType.validationFront != null) {
                validation = indexer.indexerType.validationType.validationFront ? indexer.indexerType.validationType.validationFront : 'validateIfIsEmpty';
                custom_validation = 'utility.validation.' + validation + '(this)';
              }
              mask_TAG = indexer.indexerType.validationType.mask;
            }

            const indexerMaxLength = indexer.maxLenght ? parseInt(indexer.maxLenght) : null;
            const maxLength = mask_TAG ? null : indexerMaxLength;

            return {
              alert: indexer.alert,
              hasAlert_TAG: indexer.alert != null && indexer.alert.length > 0 ? ' has-alert ' : '',
              classes: classes,
              hasDetails: indexer.hasIndexerDetails,
              details: indexer.indexerDetails,
              desired: indexer.desired ? ' has-warning ' : '',
              field_id: indexer.fieldId,
              group: indexer.group,
              group_id: indexer.groupId,
              parent_id: indexer.parentId,
              indexer_id: indexer.indexerId,
              days_restriction: indexer.qtyDaysRestriction,
              indexer_label: indexer.label,
              indexer_name: indexer.indexerName,
              indexer_type_name: indexer.indexerType.name,
              indexer_type: indexer.indexerType.dataType.dataTypeInitials,
              has_datepicker_TAG: (indexer.indexerType.dataType.dataTypeInitials == 'D' ? ' has-datepicker ' : ''),
              sequence: indexer.sequence,
              list: indexer.list,
              custom_validation: custom_validation,
              mask_TAG: mask_TAG,
              flagStickField_TAG: (indexer.flagStickField ? ' stick ' : ''),
              multiple: indexer.multiple,
              max_TAG: (indexer.maxLenght ? '9'.repeat(parseInt(indexer.maxLenght)) : null),
              maxLength_TAG: maxLength,
              readOnly_TAG: readOnly_TAG,
              readOnly: indexer.readonly || indexer.readOnly,
              let_type_TAG: let_type_TAG,
              required: indexer.required,
              required_TAG: indexer.required ? 'required' : '',
              uniqueId: indexer.uniqueId,
              value: (indexer.indexerValue
                && indexer.indexerValue.length > 0
                ? indexer.indexerValue
                : '')
              }
            });

            var result = { commonIndexersHTML: '', multipleDateHTML: '' };

            utility.renderArray('common/indexerForCapture', indexers)
              .then(function(html){
                result.commonIndexersHTML = html;
              })
              .then(function(){
                resolve(result);
              });
            });
        },
        getIndexersIntegrationHTML: function(servicesIndexers,sameIntegration){
          var prmsGetServiceBlock = [];
          var serviceBlocks = [];
          var serviceIndexers, serviceBlock, serviceHTML, servicesHTML = '';
          for(var i = 0; i < servicesIndexers.length; i++){
            serviceIndexers = $.extend({}, servicesIndexers[i]);
            
            prmsGetServiceBlock.push(
              new Promise(function(resolve){
                utility.draw.getCaptureIndexersHTML(serviceIndexers.indexers)
                .then(function(indexers){
                  serviceBlock = {
                    id: serviceIndexers.id,
                    indexers: indexers.commonIndexersHTML
                  }
                  
                  servicesHTML += '<div class="service ' + (sameIntegration ? ' integration-resolved ' : '') + '" service_id="' + serviceIndexers.id + '">' + indexers.commonIndexersHTML + '</div>';
                  
                  serviceBlocks.push(serviceBlock);
                  resolve();
                })
              })
              );
            }
            
            return Promise.all(prmsGetServiceBlock).then(function(){
              return new Promise(function(resolve){
                resolve(servicesHTML);
              })
              return utility.renderArray('common/indexersIntegration', serviceBlocks)
            });
          },
          getIndexersHTML: function(indexers, classes){
            return new Promise(function(resolve){
              var indexer_id, hasValidation, custom_validation, mask_TAG, let_type_TAG, required_TAG, readOnly_TAG, validation;
              indexers = $.map(indexers, function(indexer){
                custom_validation = '';
                mask_TAG = '';
                let_type_TAG = indexer.let_type ? ' let_type ' : '';
                readOnly_TAG = indexer.readonly || indexer.readOnly ? ' readonly ' : '';
                hasValidation = indexer.indexerType.validationType != null;
                if(hasValidation && indexer.indexerType.validationType.validationFront != null){
                  validation = indexer.indexerType.validationType.validationFront ? indexer.indexerType.validationType.validationFront : 'validateIfIsEmpty';
                  custom_validation = 'utility.validation.' + validation + '(this)';
                  mask_TAG = indexer.indexerType.validationType.mask;
                }

                const indexerMaxLength = indexer.maxLenght ? parseInt(indexer.maxLenght) : null;
                const maxLength = mask_TAG ? null : indexerMaxLength;

                return {
                  classes: classes,
                  desired: indexer.desired ? ' has-warning ' : '',
                  parent_id: indexer.parentId,
                  indexer_id: indexer.indexerId,
                  days_restriction: indexer.qtyDaysRestriction,
                  indexer_label: indexer.label,
                  indexer_type_name: indexer.indexerType.name,
                  indexer_type: indexer.indexerType.dataType.dataTypeInitials,
                  has_datepicker_TAG: (indexer.indexerType.dataType.dataTypeInitials == 'D' ? ' has-datepicker ' : ''),
                  sequence: indexer.sequence,
                  list: indexer.list,
                  custom_validation: custom_validation,
                  mask_TAG: mask_TAG,
                  flagStickField_TAG: (indexer.flagStickField ? ' stick ' : ''),
                  multiple: indexer.multiple,
                  max_TAG: (indexer.maxLenght ? '9'.repeat(parseInt(indexer.maxLenght)) : null),
                  maxLength_TAG: maxLength,
                  readOnly_TAG: readOnly_TAG,
                  let_type_TAG: let_type_TAG,
                  required: indexer.required,
                  required_TAG: indexer.required ? 'required' : '',
                  value: indexer.indexerValue ? indexer.indexerValue : ''
                }
              });
              
              var result = { commonIndexersHTML: '', multipleDateHTML: '' };
              utility.renderArray('common/indexer',indexers).then(function(html){
                result.commonIndexersHTML = html;
              }).then(function(){
                resolve(result);
              });
            });
          }
        },
        forms: {
          init: function(){
            utility.forms.oninput();
            utility.forms.initializeCheckboxes();
          },
          match: {
            integer: function(val){
              return val.match(/[0-9]+/g).join('');
            }
          },
          initializeCheckboxes: function() {
            $('input[type="checkbox"][value]').each(function() {
              var indexer = $(this).parents('.indexer.required');
              
              if(indexer.length) {
                
                if(!indexer.find('input[type="checkbox"][value]:checked').length) {
                  var firstCheckbox = indexer.find('input[type="checkbox"][value]')[0];
                  firstCheckbox.setCustomValidity('Você precisa selecionar pelo menos uma opção.');
                }
                
                $(this).on('change', function() {
                  var indexer = $(this).parents('.indexer.required');
                  var firstCheckbox = indexer.find('input[type="checkbox"][value]')[0];
                  
                  firstCheckbox.setCustomValidity(
                    indexer.find('input[type="checkbox"][value]:checked').length
                    ? ''
                    : 'Você precisa selecionar pelo menos uma opção.'
                    );
                  });
                }
              });
            },
            oninput: function(){
              $('input, select').each(function(){
                if($(this).is('input')){
                  if($(this).is('[indexer_type="D"]') || $(this).is('[has-datepicker]')){
                    $(this).unbind('change').on('change',function(){
                      if($(this).is('[custom_validation]')){
                        if($(this).attr('custom_validation').length > 0){
                          eval($(this).attr('custom_validation'))
                          .then(function(input){
                            input.setCustomValidity('');
                            
                            if(!input.checkValidity()){
                              $(input).parent().addClass('has-error');
                            } else{
                              $(input).parent().removeClass('has-error');
                            }
                          })
                          .catch(function(input){
                            if(input.value && input.value.length) {
                              $(input).parent().addClass('has-error');
                            }
                            else if(input.required) {
                              $(input).parent().addClass('has-error');
                            }
                          });
                        }
                      }
                      else if(!$(this)[0].checkValidity()){
                        $(this).parent().addClass('has-error');
                      }
                      else{
                        $(this).parent().removeClass('has-error');
                      }
                    });
                  }
                  else{
                    if($(this).is(':not([indexer_type="V"])')){
                      $(this).unbind('keyup').on('keyup',function(){
                        if($(this).is('[custom_validation]')){
                          if($(this).attr('custom_validation').length > 0){
                            eval($(this).attr('custom_validation'))
                            .then(function(input){
                              input.setCustomValidity('');
                              
                              if(!input.checkValidity()){
                                $(input).parent().addClass('has-error');
                              } else{
                                $(input).parent().removeClass('has-error');
                              }
                            })
                            .catch(function(input){
                              $(input).parent().addClass('has-error');
                            });
                          }
                        }
                        else if(!$(this)[0].checkValidity()){
                          $(this).parent().addClass('has-error');
                        }
                        else{
                          $(this).parent().removeClass('has-error');
                        }
                      });
                    }
                  }
                }
                else if($(this).is('select')){
                  $(this).unbind('input').on('input',function(){
                    if($(this).is('[required]') && $(this).find('option:selected').val() == ''){
                      $(this).parent().addClass('has-error');
                    }
                    else{
                      $(this).parent().removeClass('has-error');
                    }
                  });
                }
              });
            },
            serializeToJSON: function(form){
              var json = {};
              
              $(form).find('input:not([rm])').each(function(){
                var value;
                var input_name = $(this).attr('name');
                var json_parent = {};
                
                
                if($(this).is('[type="date"]')){
                  value = utility.date.correct($(this).val());
                }
                else if($(this).is('[integer]')){
                  value = utility.forms.match.integer($(this).val());
                } else{
                  value = $(this).val();
                }
                
                if($(this).is('[json_parent]')){
                  json_parent[input_name] = value;
                  json[$(this).attr('json_parent')] = json_parent;
                } else{
                  json[input_name] = value;
                }
              });
              
              return json;
            },
            validate: function(form_id){
              var isValid = true;
              
              $('#' + form_id).find('input, textarea, select').each(function(){
                
                if(!$(this).is(':visible')) {
                  return;
                }
                
                if($(this).is('input') || $(this).is('textarea')){
                  if(!$(this)[0].checkValidity()){
                    $(this).parent().addClass('has-error');
                    isValid = false;
                  }
                  else if($(this).is('[custom_validation]')){
                    // eval($(this).attr('custom_validation'));
                  }
                  else{
                    $(this).parent().removeClass('has-error');
                  }
                }
                else if($(this).is('select')){
                  if($(this).is('[required]') && ($(this).find('option').length == 0 || $(this).find('option:selected').val() == '')){
                    $(this).parent().addClass('has-error');
                    isValid = false;
                  }
                  else{
                    $(this).parent().removeClass('has-error');
                  }
                }
              });
              
              $('#' + form_id + ' .indexer[type="C"].required').each(function() {
                if(!$(this).find('input:checked').length) {
                  isValid = false;
                }
              });
              
              $('#' + form_id).find('input[type="submit"]').click();
              
              return isValid;
            }
          },
          handle: {
            error: function(error, message){
              utility.notification.error('Erro', message);
              throw new Error(message);
            }
          },
          masks: {
            init: function(clear) {
              $('[mask]').each(function() {
                if ($(this).attr('mask').length > 0) {
                  try {

                    const maskInput = $(this).attr('mask');
                    const maskValues = maskInput.split(', ');

                    if (maskValues.length > 1) {
                      const maskOptions = maskValues.reduce(
                        (acc, value) => {
                          return {
                            mask: [
                              ...acc.mask,
                              { mask: utility.masks.maskTransform(value) },
                            ],
                          };
                        },
                        { mask: [] }
                      );
                      new IMask(this, maskOptions);
                      return;
                    }

                    $(this).setMask({ mask: $(this).attr('mask') });
                  } catch (e) {}
                }
              });

              if(clear){
                $('[indexer_type="V"]').each(function(){
                  if($(this).val().length == 0){
                    try{ $(this).mask(''); }
                    catch(e){ $(this).setMask(''); }
                  }
                });
              }
              
              try {
                if(i$('[indexer_type="V"]').mask('##0.##0.##0,00', {
                  reverse: true,
                }));
                else($('[indexer_type="V"] input').mask('##0.##0.##0,00', {
                  reverse: true,
                }));
              } catch (e) {
                $('[indexer_type="V"]').setMask({
                  mask: '99,999.999.999.999',
                  type: 'reverse',
                  textAlign: false,
                });
              }

            $('[pmask]').each(function(){
              var pmask = $(this).attr('pmask');
              
              switch(pmask){
                case 'cpf_cnpj':
                $(this).on('input',function(){
                  var val = $(this).val();
                  if(val.length <= 11 || (val.length <= 14 && val.indexOf('.') != -1)){
                    if(!$(this).hasClass('cpf')){
                      try{ $(this).addClass('cpf').mask('999.999.999-999'); }
                      catch(e){ $(this).addClass('cpf').mask('999.999.999-999'); }
                    }
                  } else{
                    if($(this).hasClass('cpf'))
                    $(this).val($(this).val().replace(/[^0-9]/g, '')).removeClass('cpf').mask('99.999.999/9999-99');
                  }
                });
                break;
              }
            });
          },
          maskTransform: function(mask) {
            if (!mask) {
              return;
            }

            const lettersReplaced = mask.replaceAll(/[a-z]/gi, 'a');
            const numbersReplaced = lettersReplaced.replace(/\d/g, '0');

            return numbersReplaced.trim();
          }
        },
        fields: {
          init: function(){
            $('[readonly]').attr('tabindex','-1');
          }
        },
        removeCommas: function(input){
          $(input).val(input.value.replace(/[.]/g,'').trim());
        },
        dates: {
          init: function(){
            $('[days_restriction]').each(function(){
              $(this).attr('custom_validation','utility.validation.dateRestriction(this,' + $(this).attr('days_restriction') + ')');
            });
            
            utility.forms.oninput();
            
            if(helper.screen == 'captura'){
              $("[has-datepicker]:not([readonly])")
              .each(function(i) {
                $(this).attr('id', $(this).attr('class') + parseInt(i+1));
                $(this)
                .datepicker({
                  format: "dd/mm/yyyy",
                  orientation: "bottom auto",
                  language: "pt-BR",
                  autoclose: true
                });
              });
            } else{
              $("[has-datepicker]:not([readonly])")
              .each(function(i) {
                $(this).attr('id', $(this).attr('class') + parseInt(i+1));
                $(this)
                .removeClass("hasDatepicker")
                .datepicker('destroy')
                .datepicker({
                  dateFormat: "dd/mm/yy"
                });
              });
              
            }
          },
          initializeMultipleDates: function(indexersSelector) {
            $(indexersSelector + ' .indexer.multidate [sequence]').each(function(){
              $(this).unbind('change').on('change',function(){
                var desiredLength = $(this).val();
                
                if(desiredLength > 60){
                  desiredLength = 60;
                  $(this).val(desiredLength);
                }
                
                var indexer_div = $(this).parents('.indexer.multidate');
                
                var daysRestriction = $(indexer_div).is('[days_restriction]') ? parseInt($(indexer_div).attr('days_restriction')) : null;
                
                var fieldsLength = $(indexer_div).find('.multidates .field').length;
                var count = fieldsLength + 1;
                
                var diff;
                if(fieldsLength < desiredLength){
                  diff = desiredLength - fieldsLength;
                  
                  var required_TAG = $(indexer_div).find('input').is('[min="1"]') ? ' required ' : '';
                  
                  var daysRestriction_TAG = daysRestriction ? ' days_restriction="' + daysRestriction + '" ' : '';
                  
                  var indexerName = $(indexer_div).find('input').attr('indexer_name');
                  var field_HTML
                  for(var i = 0; i < diff; i++){
                    field_HTML = '<div class="field">' +
                    '	<div class="form-group">' +
                    '		<input type="text" class="form-control" has-datepicker mask="99/99/9999"' + required_TAG + daysRestriction_TAG + ' placeholder="' + indexerName + ' ' + (count++) + '"/>' +
                    '	</div>' +
                    '</div>';
                    $(indexer_div).find('.multidates').append(field_HTML);
                  }
                  utility.dates.init();
                  utility.masks.init();
                } else if(fieldsLength > desiredLength){
                  diff = fieldsLength - desiredLength;
                  var fields = $(indexer_div).find('.multidates .field');
                  
                  for(var i = fields.length - 1; i >= fields.length - diff; i--){
                    $(fields[i]).remove();
                  }
                }
              });
            });
          }
        },
        datesForms: {
          init: function(){
            $("[has-datepicker]:not([readonly])").datepicker({
              format: "dd/mm/yyyy",
              orientation: "bottom auto",
              language: "pt-BR",
              autoclose: true
            });
          }
        },
        notification: {
          error: function(title,message){
            $.gritter.add({
              title: title,
              text: message,
              class_name: 'gritter-error'
            });
          },
          success: function(title,message){
            $.gritter.add({
              title: title,
              text: message,
              class_name: 'gritter-success'
            });
          },
          warning: function(title,message){
            $.gritter.add({
              title: title,
              text: message,
              class_name: 'gritter-warning'
            });
          }
        },
        renderArray: function(path,array){
          if(!Array.isArray(array)){
            throw new Error('Array não encontrado');
          }
          return new Promise(function(resolve){
            var object, objects = [], object_promises = [];
            for(var i = 0; i < array.length; i++){
              object = array[i];
              
              objects.push({
                rendered: null
              });
              
              object_promises.push(utility.render(path,object,i).then(function(obj){
                objects[obj.index].rendered = obj.rendered;
              }));
            }
            return Promise.all(object_promises).then(function(){
              var objects_HTML = '';
              $.each(objects,function(i,object){
                objects_HTML += object.rendered;
              });
              resolve(objects_HTML);
            });
          });
        },
        render: function(path,object,i){
          return new Promise(function(resolve){
            $.get(reference + '/templates/' + path + '.nunjuck',function(template){
              if(typeof(i) == 'undefined')
              resolve(nunjucks.renderString(template, object));
              else
              resolve({ index: i, rendered: nunjucks.renderString(template, object) },i);
            });
          })
        },
        services: {
          path: "https://homolog.vianuvem.com.br/AdminVianuvemV3/api/",
          ajax: function(stringify,method,url,params,callback,callback_error){
            var obj_ajax = $.ajax({
              type: method,
              url: (method == 'GET' || method == 'DELETE' ? utility.services.path + url + '/' + params : utility.services.path + url),
              data: method == 'GET' || method == 'DELETE' ? null : (stringify ? JSON.stringify(params) : params),
              dataType: 'json',
              contentType: "application/json",
              headers: {
                JWT: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiZmFiaW8uYWx2ZXNAdmlhbnV2ZW0uY29tLmJyIiwicGFzc3dvcmQiOiJlNTBkMjkyOTc0NTgxNGE5N2UwMjA5OGZhMjQ3NWIwZCIsInVzZXJJZCI6NDcwOH0.NAHAb2oXAIBIupTRyWQdIkyid4ZJrtF95zZ9BcBMIPE'
              },
              success: function (result) {
                if (typeof(callback) === "function")
                callback(result);
                else console.log(callback);
              },
              error: function (ex, e) {
                if (typeof(callback_error) === "function")
                callback_error(ex);
                else utility.showError(ex);
              }
            }).done(function () {
              return obj_ajax;
            });
          }
        },
        sidebar: {
          init: function(){
            utility.sidebar.toggle();
          },
          toggle: function(){
            $('#page-container').addClass('page-sidebar-minified');
            
            $('[data-click="sidebar-minify"]').on('click',function(){
              $('#page-container').toggleClass('page-sidebar-minified');
            });
          }
        },
        showError: function(error){
          var msg = JSON.parse(error.responseText).returnedMessage;
          $.gritter.add({
            title:"Erro!",
            text: msg,
            image:"",
            sticky:false,
            time:"3000"
          });
        },
        toggleCheck: function(inputRadio){
          $('[name="' + inputRadio + '"]').prop('checked',!($('[name="' + inputRadio + '"]').prop('checked')));
        },
        validation: {
          document: {
            validateCpfCnpj: function(input){
              return new Promise(function(resolve,reject){
                var val = $(input).val().replace(/[^0-9]/g, '');
                if(val.length > 11){
                  utility.validation.document.validateCnpj(input)
                  .then(resolve)
                  .catch(reject);
                } else{
                  utility.validation.document.validateCpf(input)
                  .then(resolve)
                  .catch(reject);
                }
              })
            },
            validateCnpj: function(input){
              return new Promise(function(resolve,reject){
                var val = $(input).val();
                
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                  return;
                }
                
                cnpj = val.replace(/[^\d]+/g,'');
                
                if (cnpj == '') {
                  return false;
                }
                
                if (cnpj.length != 14) {
                  input.setCustomValidity('CNPJ Inválido');
                  reject(input);
                  return;
                }
                
                if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999") {
                  input.setCustomValidity('CNPJ Inválido');
                  reject(input);
                  return;
                }
                
                tamanho = cnpj.length - 2
                numeros = cnpj.substring(0,tamanho);
                digitos = cnpj.substring(tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) {
                    pos = 9;
                  }
                }
                
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(0)) {
                  input.setCustomValidity('CNPJ Inválido');
                  reject(input);
                  return;
                }
                
                tamanho = tamanho + 1;
                numeros = cnpj.substring(0,tamanho);
                soma = 0;
                pos = tamanho - 7;
                
                for (i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) {
                    pos = 9;
                  }
                }
                
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(1)) {
                  input.setCustomValidity('CNPJ Inválido');
                  reject(input);
                  
                } else {
                  input.setCustomValidity('');
                  resolve(input);
                }
              });
            },
            validateCpf: function(input){
              return new Promise(function(resolve,reject) {
                var val = $(input).val();
                
                if (val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                  return;
                }
                
                var cpf = val.replace(/[^0-9]/g, '');
                if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999"){
                  input.setCustomValidity('CPF inválido');
                  reject(input);
                  return;
                }
                
                var add = 0;
                for (i=0; i < 9; i ++) {
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                }
                
                var rev = 11 - (add % 11);
                if (rev == 10 || rev == 11) {
                  rev = 0;
                }
                
                if (rev != parseInt(cpf.charAt(9))) {
                  input.setCustomValidity('CPF inválido');
                  reject(input);
                  return;
                }
                
                add = 0;
                for (i = 0; i < 10; i ++) {
                  add += parseInt(cpf.charAt(i)) * (11 - i);
                }
                
                rev = 11 - (add % 11);
                if (rev == 10 || rev == 11) {
                  rev = 0;
                }
                
                if (rev != parseInt(cpf.charAt(10))) {
                  input.setCustomValidity('CPF inválido');
                  reject(input);
                  
                } else {
                  input.setCustomValidity('');
                  resolve(input);
                }
              });
            },
            validateEmail: function(input){
              return new Promise(function(resolve,reject){
                const val = $(input).val();
                const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
  
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                }
  
                if(val && !val.match(emailRegex)){
                    input.setCustomValidity("O email deve conter o formato 'exemplo@exemplo.com'");
                    reject(input);
                }
                else{
                    resolve(input);
                  }
              });
            },
            validateColor: function(input){
              return new Promise(function(resolve,reject){
                const val = $(input).val();
  
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                }
  
                if(val && val.match(/^[a-zA-Z\s]+$/)){
                  resolve(input);
                }
                else{
                  input.setCustomValidity("A cor deve conter apenas letras");
                  reject(input);
                }
              });
            },
            validateChassi: function(input){
              return new Promise(function(resolve,reject){
                const val = $(input).val();
                
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                }
    
                if(val.length !== 17 || !val.match(/^[^A-HJ-NPR-Z][A-HJ-NPR-Z0-9]{16}$/i)){
                  input.setCustomValidity("O número do chassi deve conter no máximo 17 caracteres e incluir apenas letras e números");
                  reject(input);
                } else{
                  resolve(input);
                }
              });
            },
            validateYear: function (input) {
              return new Promise(function (resolve, reject) {
                const val = $(input).val();
    
                if (val.length == 0) {
                  input.setCustomValidity("");
                  resolve(input);
                }
                if (val && val.match(/^\d{4}(\/\d{4})?$/)) {
                    resolve(input);
                } else {
                  input.setCustomValidity("O ano deve estar no formato 'YYYY ou YYYY/YYYY'");
                  reject(input);
                }
              });
            },
            validateCellphone: function(input){
              return new Promise(function(resolve,reject){                
                const value = $(input).val();
                const onlyNumbers = value.replace(/\D/g, '');
                const isCellPhone = /^[0-9]{2}9[0-9]{8}$/.test(onlyNumbers);
    
                if(value && isCellPhone){ 
                    resolve(input);
                } else{
                    input.setCustomValidity("Celular inválido");
                    reject(input);
                }
              });
            },
            validateRenavam: function(input){
              return new Promise(function(resolve,reject){
                  const val = $(input).val();
                  let renavamNumber = val 
    
                  if(renavamNumber.length == 0){
                    input.setCustomValidity('');
                    resolve(input);
                  }
                  
                  if(renavamNumber.length === 9){
                    renavamNumber = `00${renavamNumber}`
                  }
                  const validateCheckDigit = (renavamNumber) => {
                      if(renavamNumber.length > 11 || renavamNumber === '00000000000'){
                          return false
                      }
                      const multiplierWeight = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
                      const sumRenavamNumber = multiplierWeight.reduce((acc, curr, index) => {
                        return acc + parseInt(renavamNumber.charAt(index), 10) * curr;
                      }, 0);
                  
                      let digit = sumRenavamNumber % 11;
                      digit = digit < 2 ? 0 : 11 - digit;
                  
                      return digit === parseInt(renavamNumber.charAt(10), 10);
                  }
                  
                  if(renavamNumber.length == 11 && renavamNumber.match(/^[0-9]{11}$/) && validateCheckDigit(renavamNumber)){ 
                      resolve(input);
                  } else{
                      input.setCustomValidity("RENAVAM inválido");
                      reject(input);
                  }
              });
            }, 
            validateCurrency: function(input){
              return new Promise(function(resolve,reject){
                const val = $(input).val();
                
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                }
                
                if(val.match(/^\d{1,3}(\.\d{3})*,\d{2}$/) && val.charAt(0) !== '0'){
                  resolve(input);
                } else{
                  input.setCustomValidity("Valor inválido.");
                  reject(input);
                }
              });
            },
            validatePlate: function(input){
              return new Promise(function(resolve,reject){                
                const value = $(input).val();
                const PLATE_LENGTH = 7;
                const sanitizeValue = value.replace(/[^\s|^a-zA-Z0-9]/gi, '');
                const isPlate = sanitizeValue.length === PLATE_LENGTH;
                const isValidPlate = sanitizeValue.match(/[a-zA-Z]{3}\d{4}/g);
                const isValidMercosurPlate = sanitizeValue.match(/[a-zA-Z]{3}\d{1}[a-zA-Z]{1}\d{2}/g);

                if (value.length == 0) {
                  input.setCustomValidity('');
                  resolve(input);
                }
    
                if (value && isPlate && (isValidPlate || isValidMercosurPlate)) {
                  resolve(input);
                } else {
                  input.setCustomValidity("A placa deve conter 7 caracteres e seguir o sistema alfanumérico");
                  reject(reject);
                }
              });
            }
          },
          dateRestriction: function(input, dateRestriction){
            return new Promise(function(resolve, reject) {
              
              if (!input || !input.value) {
                input.setCustomValidity('');
                resolve(input);
              }
              
              if (!input.value.match(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i)) {
                input.setCustomValidity("A data deve estar nesse formato 'DD/MM/YYYY'");
                reject(input);
                return;
              }
              
              if(dateRestriction > 0){
                var val = $(input).val();
                
                if(val.length == 0){
                  input.setCustomValidity('');
                  resolve(input);
                }
                
                var today = moment(moment().format('DD/MM/YYYY'),'DD/MM/YYYY');
                var date_input = moment(val,'DD/MM/YYYY');
                var min_date = today.add(dateRestriction,'days');
                
                if(min_date.diff(date_input,'days') <= 0){
                  resolve(input);
                }
                else{
                  input.setCustomValidity("A data deve ser superior ou igual ao dia " + min_date.format('DD/MM/YYYY'));
                  reject(input);
                }
              } else if (dateRestriction == 0) {
                var val = $(input).val(),
                today = moment(moment().format('DD/MM/YYYY'),'DD/MM/YYYY'),
                date_input = moment(val,'DD/MM/YYYY');
                
                if (date_input.diff(today, 'days') >= 0) {
                  resolve(input);
                } else {
                  input.setCustomValidity("A data deve ser superior ou igual ao dia " + today.format('DD/MM/YYYY'));
                  reject(input);
                }
              } else {
                resolve(input);
              }
            });
          },
          validateDate: function(input){
            return new Promise(function(resolve,reject){
              var val = $(input).val();
              
              if(val.length == 0){
                input.setCustomValidity('');
                resolve(input);
              }
              
              if(val.length == 10){
                
                Date.prototype.isValid = function () {
                  return this.getTime() === this.getTime();
                };
                
                var d = new Date(val.substr(6,4)+'/'+val.substr(3,2)+'/'+val.substr(0,2));
                
                if(d.isValid())
                resolve(input);
                else{
                  input.setCustomValidity("A data deve estar nesse formato 'DD/MM/YYYY'");
                  reject(input);
                }
              } else{
                input.setCustomValidity("A data deve estar nesse formato 'DD/MM/YYYY'");
                reject(input);
              }
            });
          },
          validateBoard: function(input){
            return new Promise(function(resolve,reject){
              var board = $(input).val();
              
              if(board.length == 0){
                input.setCustomValidity('');
                resolve(input);
              }
              
              if(board.length > 3 && board.indexOf('-') == -1){
                board = board.slice(0,3) + '-' + board.slice(3);
              }
              
              if(board.length > 8){
                board = board.slice(0,8);
              }
              
              $(input).val(board.toUpperCase());
              
              var letters, numbers;
              
              if(board.length < 7){
                input.setCustomValidity("A placa deve conter pelo menos 7 caracteres no formato (ABC1234)");
                reject(input);
              }
              
              if(board.indexOf('-') != -1){
                if(board.length != 8){
                  input.setCustomValidity("A placa deve conter 8 caracteres no formato (ABC-1234)");
                  reject(input);
                }
                else{
                  letters = board.substring(0,3);
                  numbers = board.substring(4);
                  
                  validateLettersAndNumbers(input,letters,numbers);
                }
              } else{
                if(board.length != 7){
                  input.setCustomValidity("A placa deve conter 7 caracteres no formato (ABC1234)");
                  reject(input);
                }
                else{
                  letters = board.substring(0,3);
                  numbers = board.substring(3);
                  
                  validateLettersAndNumbers(input,letters,numbers);
                }
              }
              
              resolve(input);
              
              function validateLettersAndNumbers(input,letters,numbers){
                if(!/^([A-Z]{3})$/.test(letters) || !/^([0-9]{4})$/.test(numbers)){
                  input.setCustomValidity("A placa deve conter o formato (ABC1234)");
                  reject(input);
                }
              }
            });
          },
          validateIfIsEmpty: function(input){
            return new Promise(function(resolve,reject){
              var val = $(input).val();
              
              if(val.length > 0){
                resolve(input);
              } else{
                reject(input);
              }
            });
          },
          validatePassword: function(input){
            return new Promise(function(resolve,reject){
              var val = $(input).val();
              
              if(val.length > 0){
                if($('#' + $(input).attr('confirm')).val() == 0)
                resolve(input);
                else if($('#' + $(input).attr('confirm')).val() == val)
                resolve(input);
                else{
                  input.setCustomValidity("As senhas não coincidem");
                  reject(input);
                }
              } else{
                reject(input);
              }
            });
          },
          validatePasswordConfirmation: function(input){
            return new Promise(function(resolve,reject){
              var val = $(input).val();
              
              if(val.length > 0){
                if($('#' + $(input).attr('confirm_for')).val() == val)
                resolve(input);
                else{
                  input.setCustomValidity("As senhas não coincidem");
                  reject(input);
                }
              } else{
                reject(input);
              }
            });
          }
        },
        URLtoFile: function(url,filename){
          return new Promise(function(resolve){
            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.responseType = 'blob';
            request.onload = function() {
              var reader = new FileReader();
              reader.readAsDataURL(request.response);
              reader.onload =  function(e){
                resolve(dataURLtoFile(e.target.result,filename));
              };
            };
            request.send();
          });
          
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
          }
        }
      }